import {Datapoint} from '@deviceinsight/ng-ui-api-client';

type BaseInfoWidgetItem<T extends 'datapoint' | 'property'> = {
	label: string;
	type: T;
};
export const InfoWidgetItemCategory = {
	DATAPOINT: 'datapoint',
	PROPERTY: 'property'
};
export type InfoWidgetDatapoint = BaseInfoWidgetItem<'datapoint'> & {
	datapoint: Datapoint | undefined;
	decimalPoints: number;
};
export type InfoWidgetProperty = BaseInfoWidgetItem<'property'> & {
	propertyKey: string | undefined;
};
export type InfoWidgetItem = InfoWidgetDatapoint | InfoWidgetProperty;
export type InfoWidgetValueItem = {
	type: 'datapoint' | 'property';
	value: any;
	identifier: string;
};
export type TableItem = {
	item: InfoWidgetItem;
	key: string;
	value: any;
};

export function isInfoWidgetDatapoint(infoWidget: InfoWidgetItem): infoWidget is InfoWidgetDatapoint {
	return infoWidget.type === InfoWidgetItemCategory.DATAPOINT;
}

export function isInfoWidgetProperty(infoWidget: InfoWidgetItem): infoWidget is InfoWidgetProperty {
	return infoWidget.type === InfoWidgetItemCategory.PROPERTY;
}
